<div class="modal-header">
    <div class="row col-12">
        <div class="modal-title col-10">
            <h5>Importer sproglag: Sidste import - {{date}}</h5>
        </div>

        <div class="text-end col-2">
            <button type="button" class="btn" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
                <span aria-hidden="true"><i class="fa-solid fa-x"></i></span>
            </button>
        </div>
    </div>
</div>
<div class="modal-body" style="min-height: 400px;">
    @if(result == null && !awaitingResponse && !error) {
    Ændringer klar til importering: @if(loadingImports){<i class="fa-solid fa-spinner fa-spin-pulse"></i>
    } @else {
    {{importCount}}
    } <br>
    Sletninger klar til importering: @if(loadingDeletions){<i class="fa-solid fa-spinner fa-spin-pulse"></i>
    } @else {
    {{deleteCount}}
    } <br>
    } @else if (awaitingResponse) {
    <div class="d-flex flex-column justify-content-center align-items-center w-100" style="height: 400px">
        <div class="continuous-loader" role="status"></div>
        <h4 class="mt-2">Importerer nye sproglag</h4>
    </div>
    } @else if (error) {
    <div class="d-flex flex-column justify-content-center align-items-center w-100" style="height: 400px">
        <div class="alert alert-danger w-75" role="alert">
            <h5 class="alert-heading">Import fejlede</h5>
            <hr>
            <pre style="white-space: pre-wrap; word-wrap: break-word;">{{ error }}</pre>
        </div>
    </div>
    } @else if (successMessage) {
    <div class="d-flex flex-column justify-content-center align-items-center w-100" style="height: 400px">
        <div class="alert alert-success w-75" role="alert">
            <h5 class="alert-heading"><i class="fa-solid fa-circle-check"></i> Import succesfuld</h5>
            <hr>
            <p>{{ successMessage }}</p>
        </div>
    </div>
    }
</div>
<div class="modal-footer">
    @if(!result && !error){
    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
        (click)="activeModal.dismiss('Cross click')">Annuller</button>
    <button type="button" class="btn btn-primary" (click)="importTranslations()">Importer</button>
    } @else if (error) {
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss('Cross click')">Luk</button>
    <button type="button" class="btn btn-primary" (click)="importTranslations()">Prøv igen</button>
    } @else {
    <button type="button" class="btn btn-primary" (click)="accept('refresh')">Genindlæs Sproglag</button>
    }
</div>